import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Fade } from '@mui/material';
import { EmailVerificationType } from 'queries';

import AuthLayout from 'layouts/auth-layout';

import Banner from './components/banner';
import SentVerificationActions from './components/sent-verification-actions';
import SentVericationBanner from './components/sent-verification-banner';
import VerifyEmail from './components/verify-email';

type LocationState = {
  verificationType: EmailVerificationType;
  email?: string;
  returnPath: string;
};

const VerifyEmailPage = () => {
  const { state } = useLocation<LocationState>(); // access the state from the router history
  const [linkSent, setLinkSent] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const verificationType = state?.verificationType;
  const validationEmail = state?.email;
  const returnPath = state?.returnPath ?? '/';

  if (!verificationType) {
    return <div>Invalid verification type</div>;
  }

  if (verificationType === EmailVerificationType.UserPortalInvitationNewUser) {
    return (
      <div>EmailVerificationType.UserPortalInvitationNewUser is not supported through the UI</div>
    );
  }

  if (verificationType === EmailVerificationType.UserPortalInvitationExistingUser) {
    return (
      <div>
        EmailVerificationType.UserPortalInvitationExistingUser is not supported through the UI
      </div>
    );
  }

  if (verificationType === EmailVerificationType.UserPortalInvitationNewClient) {
    return (
      <div>EmailVerificationType.UserPortalInvitationNewClient is not supported through the UI</div>
    );
  }

  if (verificationType === EmailVerificationType.EstateClientConsentTruadmin) {
    return (
      <div>EmailVerificationType.EstateClientConsentTruadmin is not supported through the UI</div>
    );
  }

  if (verificationType === EmailVerificationType.EstateClientConsentTruplanning) {
    return (
      <div>
        EmailVerificationType.EstateClientConsentTruplanning is not supported through the UI
      </div>
    );
  }

  if (verificationType === EmailVerificationType.EstateClientConsentTruproxy) {
    return (
      <div>EmailVerificationType.EstateClientConsentTruproxy is not supported through the UI</div>
    );
  }

  if (verificationType === EmailVerificationType.EstateClientConsentTrustadmin) {
    return (
      <div>EmailVerificationType.EstateClientConsentTrustadmin is not supported through the UI</div>
    );
  }

  return (
    <AuthLayout>
      <Fade in={true}>
        <div>
          {linkSent ? (
            <>
              <SentVericationBanner userEmail={userEmail} />{' '}
              <SentVerificationActions
                email={userEmail}
                verificationType={verificationType}
                returnPath={returnPath}
              />
            </>
          ) : (
            <>
              <Banner verificationType={verificationType} />
              <VerifyEmail
                updateParent={(email: string) => {
                  setUserEmail(email);
                  setLinkSent(true);
                }}
                verificationType={verificationType}
                validationEmail={validationEmail}
                returnPath={returnPath}
              />
            </>
          )}
        </div>
      </Fade>
    </AuthLayout>
  );
};

export default VerifyEmailPage;
